const state = {
    	   
        stores       : [],
        Id           : 0,
        img_url      : '',
        img_num      : 0,
        printer_type : '',
        vat          : 0,
        shopify      : 0
      
}

const mutations = {
    
    'SET_COMPANY_STORES' (state,stores)
    {
        state.stores = stores
    },

    'SET_COMPANY' (state,{reset,Id,printer_type,vat,shopify})
    {   
        
      
        if(reset==true) 
        {   
            state.stores  = [] 
            state.Id      = Id
            state.img_url = ''
            state.img_num = 0
            state.printer_type = ''
            state.vat          = 0
            state.shopify = 0
            return
        }
         
        state.Id = Id
        state.printer_type = printer_type
        state.vat = vat
        state.shopify = shopify
        return

      },
    'SET_COMPANY_URL_IMG' (state,{url,num})
      {
          
        state.img_url = url
        state.img_num = num

      },
    
	

}
const actions = {

}

const getters = {
	company : (state) => {
		return state;
    },

}

export default {
	state,
	mutations,
	actions,
	getters
}